
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/grading/jst/-grading-box';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <input  name=\"";
  if (helper = helpers.inputName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.inputName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n          value=\"";
  if (helper = helpers.grade) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.grade); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n          class=\"grading_value grading_box\"\n          id=\"student_grading_"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n          aria-labelledby=\"default_grade_points\"\n          aria-describedby=\"default_grade_description\"\n          "
    + escapeExpression((helper = helpers.disabledIf || (depth0 && depth0.disabledIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.isInPastGradingPeriodAndNotAdmin), options) : helperMissing.call(depth0, "disabledIf", (depth0 && depth0.isInPastGradingPeriodAndNotAdmin), options)))
    + "\n          />\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <span name=\"";
  if (helper = helpers.inputName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.inputName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"grading_box\" id=\"student_grading_"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n    <input  name=\"";
  if (helper = helpers.inputName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.inputName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n            type=\"text\"\n            name=\"grade\"\n            value=\"";
  if (helper = helpers.grade) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.grade); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n            class=\"grading_value\"\n            aria-labelledby=\"default_grade_points\"\n            aria-describedby=\"default_grade_description\"\n            "
    + escapeExpression((helper = helpers.disabledIf || (depth0 && depth0.disabledIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.isInPastGradingPeriodAndNotAdmin), options) : helperMissing.call(depth0, "disabledIf", (depth0 && depth0.isInPastGradingPeriodAndNotAdmin), options)))
    + "\n            />\n  </span>\n";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <input  name=\"";
  if (helper = helpers.inputName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.inputName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n          type=\"text\"\n          value=\"";
  if (helper = helpers.grade) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.grade); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n          class=\"grading_value grading_box score_value\"\n          id=\"student_grading_"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n          aria-labelledby=\"default_grade_points\"\n          aria-describedby=\"default_grade_description\"\n          "
    + escapeExpression((helper = helpers.disabledIf || (depth0 && depth0.disabledIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.isInPastGradingPeriodAndNotAdmin), options) : helperMissing.call(depth0, "disabledIf", (depth0 && depth0.isInPastGradingPeriodAndNotAdmin), options)))
    + "\n          />\n";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <select name=\"";
  if (helper = helpers.inputName) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.inputName); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n          class=\"grading_value grading_box pass_fail\"\n          id=\"student_grading_"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\"\n          "
    + escapeExpression((helper = helpers.disabledIf || (depth0 && depth0.disabledIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.isInPastGradingPeriodAndNotAdmin), options) : helperMissing.call(depth0, "disabledIf", (depth0 && depth0.isInPastGradingPeriodAndNotAdmin), options)))
    + "\n          >\n    <option value=\"\">---</option>\n    <option value=\"complete\" "
    + escapeExpression((helper = helpers.selectedIf || (depth0 && depth0.selectedIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.grade), "complete", options) : helperMissing.call(depth0, "selectedIf", (depth0 && depth0.grade), "complete", options)))
    + ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("gradebooks.grades"),
    'i18n_used_in': ("grading_box")
  },data:data},helper ? helper.call(depth0, "gradebooks.grades.complete", "Complete", options) : helperMissing.call(depth0, "t", "gradebooks.grades.complete", "Complete", options)))
    + "</option>\n    <option value=\"incomplete\" "
    + escapeExpression((helper = helpers.selectedIf || (depth0 && depth0.selectedIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.grade), "incomplete", options) : helperMissing.call(depth0, "selectedIf", (depth0 && depth0.grade), "incomplete", options)))
    + ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("gradebooks.grades"),
    'i18n_used_in': ("grading_box")
  },data:data},helper ? helper.call(depth0, "gradebooks.grades.incomplete", "Incomplete", options) : helperMissing.call(depth0, "t", "gradebooks.grades.incomplete", "Incomplete", options)))
    + "</option>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.shouldShowExcusedOption), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </select>\n";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <option value=\"EX\" ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.excused), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("grading_box")
  },data:data},helper ? helper.call(depth0, "excused_cf8792eb", "Excused", options) : helperMissing.call(depth0, "t", "excused_cf8792eb", "Excused", options)))
    + "</option>\n    ";
  return buffer;
  }
function program9(depth0,data) {
  
  
  return "selected";
  }

function program11(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  <label>\n    <span id=\"default_grade_points\" style=\"font-size: 0.9em;\" >\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assignment_grading_type_is_percent), {hash:{},inverse:self.program(14, program14, data),fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </span>\n  </label>\n";
  return buffer;
  }
function program12(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("grading_box")
  },data:data},helper ? helper.call(depth0, "_b4455c8b", "%", options) : helperMissing.call(depth0, "t", "_b4455c8b", "%", options)))
    + "\n      ";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        ";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.points_possible), options) : helperMissing.call(depth0, "n", ((stack1 = (depth0 && depth0.assignment)),stack1 == null || stack1 === false ? stack1 : stack1.points_possible), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_assignment.points_possible': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("grading_box")
  },data:data},helper ? helper.call(depth0, "out_of_n_assignment_points_possible_3b026ea9", "out of %{n_assignment.points_possible}", options) : helperMissing.call(depth0, "t", "out_of_n_assignment_points_possible_3b026ea9", "out of %{n_assignment.points_possible}", options)))
    + "\n      ";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assignment_grading_type_is_points), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assignment_grading_type_is_percent), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assignment_grading_type_is_letter_grade), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assignment_grading_type_is_gpa_scale), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assignment_grading_type_is_pass_fail), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showPointsPossible), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/shared/grading/jst/_grading_box.handlebars', templates['/var/canvas/ui/shared/grading/jst/-grading-box']);
    ;
    ;
    export default templates[name];
  